<dl class="mt-5 grid grid-cols-1 rounded-lg bg-white overflow-hidden border-cgrey-80 border divide-x divide-y divide-gray-200 md:grid-cols-2">
  <div>
    <div class="px-4 py-5 sm:p-6 relative">
      <vti-info-button [type]="'startDate'">
        <dt class="text-base font-normal text-gray-900">{{ utilitiesService.startDateTitle() }}</dt>
        <dd class="mt-1 flex justify-between items-baseline md:block lg:flex">
          <div class="flex items-baseline text-2xl font-semibold text-vti">
            <span>{{ summary()?.startDate | date: 'longDate' : 'IST' : locale() }}</span>
          </div>
        </dd>
      </vti-info-button>
    </div>
  </div>
  <div>
    <div class="px-4 py-5 sm:p-6 relative">
      <vti-info-button [type]="'restored'">
        <dt class="text-base font-normal text-gray-900">{{ utilitiesService.areaRestoredTitle() }}</dt>
        <dd class="mt-1 flex justify-between items-baseline md:block lg:flex">
          <div class="flex items-baseline text-2xl font-semibold text-vti">
            <span>{{ summary()?.totalArea | number: '1.2-2' : locale() }}</span>
          </div>
        </dd>
      </vti-info-button>
    </div>
  </div>
  <div>
    <div class="px-4 py-5 sm:p-6 relative">
      <vti-info-button [type]="'protected'">
        <dt class="text-base font-normal text-gray-900">{{ utilitiesService.areaProtectedTitle() }}</dt>
        <dd class="mt-1 flex justify-between items-baseline md:block lg:flex">
          <div class="flex items-baseline text-2xl font-semibold text-vti">
            <span>{{ summary()?.protectedArea | number: '1.2-2' : locale() }}</span>
          </div>
        </dd>
      </vti-info-button>
    </div>
  </div>
  <div>
    <div class="px-4 py-5 sm:p-6 relative">
      <vti-info-button [type]="'investment'">
        <dt class="text-base font-normal text-gray-900">{{ utilitiesService.investmentTitle() }}</dt>
        <dd class="mt-1 flex justify-between items-baseline md:block lg:flex">
          <div class="flex items-baseline text-2xl font-semibold text-vti">USD&nbsp;${{ summary()?.investmentValue | number: '1.2-2' }}</div>
        </dd>
      </vti-info-button>
    </div>
  </div>
  <div>
    <div class="px-4 py-5 sm:p-6 relative">
      <vti-info-button [type]="'carbon'">
        <div>
          <dt class="text-base font-normal text-gray-900">{{ utilitiesService.carbonTitle() }}</dt>
        </div>
        <dd class="mt-1 flex justify-between items-baseline md:block lg:flex">
          <div class="flex items-baseline text-2xl font-semibold text-vti">{{ summary()?.carbonCompensations | number: '1.2-2' }}&nbsp;<span>tons CO</span><sub>2</sub></div>
        </dd>
      </vti-info-button>
    </div>
  </div>
  <div>
    <div class="px-4 py-5 sm:p-6 relative">
      <vti-info-button [type]="'assets'">
        <dt class="text-base font-normal text-gray-900">{{ utilitiesService.biologicalAssetsTitle() }}</dt>
        <dd class="mt-1 flex justify-between items-baseline md:block lg:flex">
          <div class="flex items-baseline text-2xl font-semibold text-vti">
            <span>USD&nbsp;${{ summary()?.discountedCashflow | number: '1.2-2' }}</span>
          </div>
        </dd>
      </vti-info-button>
    </div>
  </div>
  <div>
    <div class="px-4 py-5 sm:p-6 relative">
      <vti-info-button [type]="'money'">
        <dt class="text-base font-normal text-gray-900">{{ utilitiesService.moneyDistributedTitle() }}</dt>
        <dd class="mt-1 flex justify-between items-baseline md:block lg:flex">
          <div class="flex items-baseline text-2xl font-semibold text-vti">
            <span>USD&nbsp;${{ summary()?.cashDistributed | number: '1.2-2' }}</span>
          </div>
        </dd>
      </vti-info-button>
    </div>
  </div>
  <div>
    <div class="px-4 py-5 sm:p-6 relative">
      <vti-info-button [type]="'gains'">
        <dt class="text-base font-normal text-gray-900">{{ utilitiesService.capitalGainsTitle() }}</dt>
        <dd class="mt-1 flex justify-between items-baseline md:block lg:flex">
          <div class="flex items-baseline text-2xl font-semibold text-vti">
            <span>USD&nbsp;${{ summary()?.naturalCapital | number: '1.2-2' }}</span>
          </div>
        </dd>
      </vti-info-button>
    </div>
  </div>
  <div>
    <div class="px-4 py-5 sm:p-6 relative">
      <vti-info-button [type]="'damage'">
        <dt class="text-base font-normal text-gray-900">{{ utilitiesService.damageAvoidedTitle() }}</dt>
        <dd class="mt-1 flex justify-between items-baseline md:block lg:flex">
          <div class="flex items-baseline text-2xl font-semibold text-vti">
            <span>USD&nbsp;${{ summary()?.socialCost | number: '1.2-2' }}</span>
          </div>
        </dd>
      </vti-info-button>
    </div>
  </div>
  <div>
    <div class="px-4 py-5 sm:p-6 relative">
      <vti-info-button [type]="'income'">
        <dt class="text-base font-normal text-gray-900">{{ utilitiesService.landownersIncomeTitle() }}</dt>
        <dd class="mt-1 flex justify-between items-baseline md:block lg:flex">
          <div class="flex items-baseline text-2xl font-semibold text-vti">
            <span>USD&nbsp;${{ summary()?.landownersIncome | number: '1.2-2' }}</span>
          </div>
        </dd>
      </vti-info-button>
    </div>
  </div>
  <div>
    <div class="px-4 py-5 sm:p-6 relative">
      <vti-info-button [type]="'family'">
        <dt class="text-base font-normal text-gray-900">{{ utilitiesService.familiesInvolvedTitle() }}</dt>
        <dd class="mt-1 flex justify-between items-baseline md:block lg:flex">
          <div class="flex items-baseline text-2xl font-semibold text-vti">
            <span>{{ summary()?.familiesInvolved | number: '1.2-2' }}</span>
          </div>
        </dd>
      </vti-info-button>
    </div>
  </div>
  <div>
    <div class="px-4 py-5 sm:p-6 relative">
      <vti-info-button [type]="'quality'">
        <dt class="text-base font-normal text-gray-900">{{ utilitiesService.qualityHectareTitle() }}</dt>
        <dd class="mt-1 flex justify-between items-baseline md:block lg:flex">
          <div class="flex items-baseline text-2xl font-semibold text-vti">
            <span>{{ summary()?.qualityHectare | number: '1.2-2' }}</span>
          </div>
        </dd>
      </vti-info-button>
    </div>
  </div>
</dl>
